import ModalSignupConfirm from './board-modal/ModalSignupConfirm';
import ModalModifyUserState from './board-modal/ModalModifyUserState';
import ModalModifyWpUserState from './board-modal/ModalModifyWpUserState';
import ModalDeleteUser from './board-modal/ModalDeleteUser';
import ModalDeleteWpUser from './board-modal/ModalDeleteWpUser';
import ModalAbout from './board-modal/ModalAbout';
import ModalRetryLogin from './board-modal/ModalRetryLogin';
import ModalAnnouncement from './board-modal/ModalAnnouncement';

const ModalConfig = [
  {
    name: 'SignupConfirm',
    component: ModalSignupConfirm,
  },
  {
    name: 'DeleteUser',
    component: ModalDeleteUser,
  },
  {
    name: 'DeleteWpUser',
    component: ModalDeleteWpUser,
  },
  {
    name: 'ModifyUserState',
    component: ModalModifyUserState,
  },
  {
    name: 'ModifyWpUserState',
    component: ModalModifyWpUserState,
  },
  {
    name: 'About',
    component: ModalAbout,
  },
  {
    name: 'RetryLogin',
    component: ModalRetryLogin,
  },
  {
    name: 'Announcement',
    component: ModalAnnouncement,
  },
];

export default ModalConfig;



// WEBPACK FOOTER //
// ./src/spa/components/modal/ModalConfig.js